import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Explore our complete range of products and find exactly what you need. Click any category to discover more on the official store.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden rounded-t-xl">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2">
                  <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-[10px] font-semibold">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    Shop Now
                  </span>
                </div>
              </div>

              <div className="p-3 text-center">
                <span className="text-xs font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}